"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullAbsFlexGridLayer = exports.FullAbsFlexGrid = exports.FullAbsFlexLayer = exports.FullAbsFlexbox = exports.FullAbsDiv = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FelaCache_1 = require("../../fela/FelaCache");
const FelaFlexbox_1 = require("../fela/FelaFlexbox");
const FelaGrid_1 = require("../fela/FelaGrid");
const FelaLayers_1 = require("../fela/FelaLayers");
// React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>
const FullAbsDiv = (props) => ((0, jsx_runtime_1.jsx)("div", { ...props, style: {
        position: "absolute",
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
        content: "",
        ...props.style,
    } }));
exports.FullAbsDiv = FullAbsDiv;
const FelaRuleFullAbs = ({ pointerEvents }) => ({
    width: "100%",
    height: "100%",
    pointerEvents,
});
const FelaFullAbsFlexboxSuperRule = (0, FelaCache_1.combineRulesWithName)([FelaFlexbox_1.FelaRuleFlexbox, FelaRuleFullAbs], "FelaFullAbsFlexboxSuperRule");
const ruleKeysFelaAbsFlexboxSuper = [...new Set([...FelaFlexbox_1.ruleKeysFlexbox, "pointerEvents"])];
const FullAbsFlexbox = ({ className, children, pointerEvents = true, position = "absolute", rootProps, style, cssExtra = [], ...props }) => {
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    const { top = 0, right, left = 0, bottom } = props;
    return ((0, jsx_runtime_1.jsx)("div", { ...rootProps, style: style, className: `${className ?? ""} ${cachedClass(FelaFullAbsFlexboxSuperRule, {
            position,
            top,
            left,
            right,
            bottom,
            pointerEvents: pointerEvents ? "all" : "none",
            ...props,
        }, ruleKeysFelaAbsFlexboxSuper)} ${inlineCss(cssExtra)}`, children: children }));
};
exports.FullAbsFlexbox = FullAbsFlexbox;
const FelaFullAbsFlexLayerSuperRule = (0, FelaCache_1.combineRulesWithName)([FelaFlexbox_1.FelaRuleFlexbox, FelaLayers_1.FelaRuleLayer, FelaRuleFullAbs], "FelaFullAbsFlexLayerSuperRule");
const ruleKeysFelaFullAbsFlexLayerSuper = [
    ...new Set([...FelaFlexbox_1.ruleKeysFlexbox, ...FelaLayers_1.ruleKeysFlexLayer, "pointerEvents"]),
];
const FullAbsFlexLayer = ({ className, children, pointerEvents = true, position = "absolute", rootProps, style, cssExtra = [], ...props }) => {
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    const { top = 0, right, left = 0, bottom } = props;
    return ((0, jsx_runtime_1.jsx)("div", { ...rootProps, style: style, className: `${className ?? ""} ${cachedClass(FelaFullAbsFlexLayerSuperRule, {
            position,
            top,
            left,
            right,
            bottom,
            pointerEvents: pointerEvents ? "all" : "none",
            ...props,
        }, ruleKeysFelaFullAbsFlexLayerSuper)} ${inlineCss(cssExtra)}`, children: children }));
};
exports.FullAbsFlexLayer = FullAbsFlexLayer;
const FelaFullAbsFlexGridSuperRule = (0, FelaCache_1.combineRulesWithName)([FelaGrid_1.FelaRuleGrid, FelaRuleFullAbs], "FelaFullAbsFlexGridSuperRule");
const ruleKeysFelaAbsFlexGridSuper = [...new Set([...FelaGrid_1.ruleKeysFelaGrid, "pointerEvents"])];
const FullAbsFlexGrid = ({ className, children, pointerEvents = true, position = "absolute", rootProps, style, cssExtra = [], ...props }) => {
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    const { top = 0, right, left = 0, bottom } = props;
    return ((0, jsx_runtime_1.jsx)("div", { ...rootProps, style: style, className: `${className ?? ""} ${cachedClass(FelaFullAbsFlexGridSuperRule, {
            position,
            top,
            left,
            right,
            bottom,
            pointerEvents: pointerEvents ? "all" : "none",
            ...props,
        }, ruleKeysFelaAbsFlexGridSuper)} ${inlineCss(cssExtra)}`, children: children }));
};
exports.FullAbsFlexGrid = FullAbsFlexGrid;
const FelaFullAbsFlexGridLayerSuperRule = (0, FelaCache_1.combineRulesWithName)([FelaGrid_1.FelaRuleGrid, FelaLayers_1.FelaRuleLayer, FelaRuleFullAbs], "FelaFullAbsFlexGridLayerSuperRule");
const ruleKeysFelaAbsFlexGridLayerSuper = [
    ...new Set([...FelaGrid_1.ruleKeysFelaGrid, ...FelaLayers_1.ruleKeysFlexLayer, "pointerEvents"]),
];
const FullAbsFlexGridLayer = ({ className, children, pointerEvents = true, position = "absolute", rootProps, style, cssExtra = [], ...props }) => {
    const { cachedClass, inlineCss } = (0, FelaCache_1.useFelaCache)();
    const { top = 0, right, left = 0, bottom } = props;
    return ((0, jsx_runtime_1.jsx)("div", { ...rootProps, style: style, className: `${className ?? ""} ${cachedClass(FelaFullAbsFlexGridLayerSuperRule, {
            position,
            top,
            left,
            right,
            bottom,
            pointerEvents: pointerEvents ? "all" : "none",
            ...props,
        }, ruleKeysFelaAbsFlexGridLayerSuper)} ${inlineCss(cssExtra)}`, children: children }));
};
exports.FullAbsFlexGridLayer = FullAbsFlexGridLayer;
